import { getLogger } from "@expert/logging";
import { Flex } from "@mantine/core";
import { withErrorBoundary } from "react-error-boundary";
import { TrainingModal } from "@/components/training";
import { WorkspaceBody } from "@/components/workspace/WorkspaceBody";
import styles from "@/components/workspace/workspace.module.css";
import { ExpertUniversityHome } from "@/expert-university";
import type { TrainingTask } from "@/sdk";
import { createFallbackRender } from "@/shared-utils";

const logger = getLogger({ module: "Workspace" });

const TrainingModalHandled = withErrorBoundary(TrainingModal, { fallbackRender: createFallbackRender(logger) });

interface WorkspaceContentLeftTopASlotProps {
    showExpertUniversity: undefined | boolean;
    activeTrainingTask: TrainingTask | null;
}

export function WorkspaceContentLeftTopASlot({
    showExpertUniversity,
    activeTrainingTask,
}: WorkspaceContentLeftTopASlotProps) {
    return (
        <Flex pos={"absolute"} inset={0}>
            {showExpertUniversity ? (
                // If the conditions are met for Expert University, show the Training home page
                <ExpertUniversityHome />
            ) : activeTrainingTask?.startTimestamp ? (
                // TODO: This modal should not really be rendered here. It belongs in WorkspaceContent.tsx
                <Flex className={styles.workspaceBody} direction="row" m="2.5rem 3rem">
                    <TrainingModalHandled task={activeTrainingTask} />
                </Flex>
            ) : (
                <WorkspaceBody />
            )}
        </Flex>
    );
}
